import { Col, Container, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Form, FormGroup, Input, Label, Row } from 'reactstrap'
import { addProperty, addPropertyMeter, editPropertyMeter, getProperty, getUtilities, getUtility } from '../../Services/PortfolioService';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Breadcrumbs from '../../CommonElements/Breadcrumbs';
import Table from '../../CustomComponent/Tables/Table';
import { TableColumn } from 'react-data-table-component';
import { MoreVertical, Eye, Pencil, Unlock, Lock, Plus, Trash2 } from 'lucide-react';
import { Btn } from '../../AbstractElements';
// import Modal from '../../CustomComponent/Modals/Modal';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import SelectDropdown from '../../CustomComponent/Form/SelectDropdown';
import { useParams } from 'react-router-dom';
import { Controller, SubmitHandler } from 'react-hook-form';
import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import ActionDropdown from '../../CustomComponent/ActionDropdown';
import { sortByKey } from '../../Utils';

export const meterFormSchema = yup.object().shape({
    meter_name: yup
        .string().trim()
        .required('Meter Name is required'),

    meter_no_1: yup
        .string().trim()
        .required('Meter Number is required'),

    meter_no_2: yup
        .string().trim()
        .optional(),

    meter_type: yup
        .string().trim()
        .required('Meter Type is required'),

    site_id: yup
        .string().trim()
        .required('Site ID is required'),

    utility_id: yup
        .string().trim()
        .required('Utility is required'),

    supplier_id: yup
        .string().trim()
        .required('Supplier is required'),

    location: yup
        .string().trim()
        .optional(),
        // .required('Location is required'),

    status: yup
        .string().trim()
        .required('Status is required'),

    date_installed: yup
        .string().trim()        
        .optional(),
        // .required('Date Installed is required'),

    contract_end_date: yup
        .string().trim()        
        .optional(),
        // .required('Date Installed is required'),

    data_collector: yup
        .string().trim()
        .optional(),
        // .required('Data Collector is required'),

    meter_operator: yup
        .string().trim()
        .optional(),
        // .required('Meter Operator is required')
});

export const editMeterFormSchema = yup.object().shape({
    meter_id: yup
        .string().trim()
        .required('Meter ID is required'),

    meter_name: yup
        .string().trim()
        .required('Meter Name is required'),

    meter_no_1: yup
        .string().trim()
        .required('Meter Number is required'),

    meter_no_2: yup
        .string().trim()
        .optional(),

    meter_type: yup
        .string().trim()
        .required('Meter Type is required'),

    site_id: yup
        .string().trim()
        .required('Site ID is required'),

    utility_id: yup
        .string().trim()
        .required('Utility is required'),

    supplier_id: yup
        .string().trim()
        .required('Supplier is required'),

    location: yup
        .string().trim()
        .optional(),
        // .required('Location is required'),

    status: yup
        .string().trim()
        .required('Status is required'),

    date_installed: yup
        .string().trim()        
        .optional(),
        // .required('Date Installed is required'),
    
    contract_end_date: yup
        .string().trim()        
        .optional(),
        // .required('Date Installed is required'),

    data_collector: yup
        .string().trim()
        .optional(),
        // .required('Data Collector is required'),

    meter_operator: yup
        .string().trim()
        .optional(),
        // .required('Meter Operator is required')
});

export default function Property() {
    const { propertyId } = useParams()
    const [client, setClient] = useState<any>(null);
    const [clientId, setClientId] = useState<any>(null)
    const [property, setProperty] = useState<any>([]);
    const [meters, setMeters] = useState<any>([]);
    const [utilities, setUtilities] = useState<any>([]);
    const [suppliers, setSuppliers] = useState<any[]>([]);
    const [loading, setLoading] = useState(false)
    const [meterModalOpen, setMeterModalOpen] = useState(false);
    const toggleMeterModal = () => { setMeterModalOpen(!meterModalOpen); reset() };

    const [editProperty, setEditProperty] = useState<any>(null);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const toggleEditModal = () => setEditModalOpen(!editModalOpen);

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [address, setAddress] = useState('');
    const [contactName, setContactName] = useState('');
    const {
        control,
        handleSubmit,
        reset,
        watch,
        formState: { errors }
    } = useForm({
        resolver: yupResolver(meterFormSchema),
        defaultValues: {
            meter_name: '',
            meter_no_1: '',
            meter_no_2: '',
            meter_type: '',
            site_id: '',
            utility_id: '',
            supplier_id: '',
            location: '',
            status: '',
            date_installed: '',
            contract_end_date: '',
            data_collector: '',
            meter_operator: ''
        }
    });

    const {
        control: editControl,
        handleSubmit: editHandleSubmit,
        reset: editReset,
        watch: editWatch,
        formState: { errors: editErrors }
    } = useForm({
        resolver: yupResolver(editMeterFormSchema),
        defaultValues: {
            meter_id: '',
            meter_name: '',
            meter_no_1: '',
            meter_no_2: '',
            site_id: '',
            utility_id: '',
            supplier_id: '',
            location: '',
            status: '',
            date_installed: '',
            contract_end_date: '',
            data_collector: '',
            meter_operator: ''
        },
    });

    const utilityId = watch('utility_id');
    const editUtilityId = editWatch('utility_id');

    useEffect(() => {
        const storedClient = localStorage.getItem('selectedClient');
        if (storedClient) {
            setClientId(storedClient)
        }

        fetchUtilities()
    }, []);

    useEffect(() => {
        if (clientId && propertyId) fetchProperty();
    }, [clientId, propertyId]);

    // Fetch suppliers when utility changes
    useEffect(() => {
        if (utilityId) fetchUtility(utilityId).then(data => setSuppliers(sortByKey(data.suppliers as any[], 'name')));
        if (editUtilityId) fetchUtility(editUtilityId).then(data => setSuppliers(sortByKey(data.suppliers as any[], 'name')));
    }, [utilityId, editUtilityId]);


    const handleEditMeter: SubmitHandler<any> = async (data) => {
        try {
            const meterId = data.meter_id;
            if (!meterId) return;

            const formData = new FormData();
            formData.append('meter_name', data.meter_name);
            formData.append('meter_type', data.meter_type);
            formData.append('meter_no_1', data.meter_no_1);
            formData.append('meter_no_2', data.meter_no_2);
            formData.append('meter_type', data.meter_type);
            formData.append('site_id', data.site_id);
            formData.append('utility_id', data.utility_id);
            formData.append('supplier_id', data.supplier_id);
            formData.append('location', data.location);
            formData.append('date_installed', data.date_installed);
            formData.append('contract_end_date', data.contract_end_date);
            formData.append('data_collector', data.data_collector);
            formData.append('meter_operator', data.meter_operator);
            formData.append('status', data.status);

            await editPropertyMeter(clientId!, propertyId!, meterId, formData);
            toast.success("Meter updated!");
            fetchProperty();
            toggleEditModal();
        } catch (error: any) {
            toast.error(error.message || "Failed to update meter");
        }
    };

    const actions = [
        {
            label: 'View',
            icon: <Eye size={16} color="green" className="me-2" />,
            onClick: (row: any) =>  console.log('View', row),
        },
        {
            label: 'Edit',
            icon: <Pencil size={16} color="orange" className="me-2" />,
            onClick: (row: any) => {
                editReset({
                    meter_id: row.meter_id,
                    meter_name: row.name,
                    meter_type: row.meter_type,
                    meter_no_1: row.meter_no_1,
                    meter_no_2: row.meter_no_2,
                    site_id: row.site_id,
                    utility_id: row.utility_id,
                    supplier_id: row.supplier_id,
                    location: row.location,
                    status: row.status,
                    date_installed: row.date_installed,
                    contract_end_date: row.contract_end_date,
                    data_collector: row.data_collector,
                    meter_operator: row.meter_operator
                });
                toggleEditModal();
            },
        },
    ];

    // const ActionDropdown = ({ row }: { row: any }) => {
    //     const [dropdownOpen, setDropdownOpen] = useState(false);
    //     const toggle = () => setDropdownOpen(prevState => !prevState);

    //     return (
    //         <Dropdown isOpen={dropdownOpen} toggle={toggle} direction="down">
    //             <DropdownToggle color="transparent" className="p-0 border-0 shadow-none">
    //                 <MoreVertical size={18} />
    //             </DropdownToggle>
    //             <DropdownMenu end>
    //                 <DropdownItem onClick={() => console.log('View', row)}>
    //                     <Eye size={16} color="green" className="me-2" />
    //                     View
    //                 </DropdownItem>
    //                 <DropdownItem onClick={() => {
    //                     editReset({
    //                         meter_id: row.meter_id,
    //                         meter_name: row.name,
    //                         meter_type: row.meter_type,
    //                         meter_no_1: row.meter_no_1,
    //                         meter_no_2: row.meter_no_2,
    //                         site_id: row.site_id,
    //                         utility_id: row.utility_id,
    //                         location: row.location,
    //                         status: row.status,
    //                         date_installed: row.date_installed,
    //                         data_collector: row.data_collector,
    //                         meter_operator: row.meter_operator
    //                     });
    //                     toggleEditModal();
    //                 }}>
    //                     <Pencil size={16} color="orange" className="me-2" />
    //                     Edit
    //                 </DropdownItem>
    //                 {/* <DropdownItem onClick={() => console.log('Delete', row)}>
    //                     <Trash2 size={16} color="red" className="me-2" />
    //                     Delete
    //                 </DropdownItem> */}
    //                 {
    //                     row.status == 'no access' ?
    //                         <DropdownItem onClick={() => console.log('Delete', row)}>
    //                             <Unlock size={16} color="green" className="me-2" />
    //                             Grant Access
    //                         </DropdownItem> :
    //                         <DropdownItem onClick={() => console.log('Delete', row)}>
    //                             <Lock size={16} color="red" className="me-2" />
    //                             Revoke Access
    //                         </DropdownItem>
    //                 }
    //             </DropdownMenu>
    //         </Dropdown>
    //     );
    // };

    const tableColumns: TableColumn<any>[] = [
        {
            name: "S/N",
            cell: (_row, index) => index + 1,
            sortable: false,
            width: '70px',
        },
        {
            name: "Meter Name",
            selector: (row) => row.name,
            sortable: true,
            center: false,
            wrap: true,
            width: '170px',
        },
        {
            name: "Type",
            selector: (row) => row.meter_type,
            sortable: true,
            center: false,
            wrap: true,
            width: '120px',
            // color: 'orange'
        },
        {
            name: "Meter Number",
            selector: (row) => (
                <div>
                    <div>{row.meter_no_1 || ''}</div>
                    <div>{row.meter_no_2 || ''}</div>
                </div>
            ),
            sortable: true,
            center: false,
            wrap: true,
            width: '170px',
        },
        {
            name: "Site ID.",
            selector: (row) => `${row.site_id}`,
            sortable: true,
            center: false,
            wrap: true,
            width: '170px',
            // width: '200px',
        },
        {
            name: "Utility",
            cell: (row) => row.utility?.name || '',
            sortable: false,
            center: false,
        },
        {
            name: "Data Collector",
            cell: (row) => row.data_collector || '',
            sortable: false,
            center: false,
        },
        {
            name: "Meter Operator",
            cell: (row) => row.meter_operator || '',
            sortable: false,
            center: false,
        },
        {
            name: "Status",
            cell: (row) => row.status ? row.status.charAt(0).toUpperCase() + row.status.slice(1) : '',
            sortable: false,
            center: true,
        },
        {
            name: 'Actions',
            cell: (row) => <ActionDropdown row={row} actions={actions} />,
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
            width: '70px',
        },
    ];

    const utilityOptions = utilities.map((utility: any) => ({ label: utility.name, value: utility.utility_id }));
    const supplierOptions = suppliers.map((supplier: any) => ({ label: supplier.name, value: supplier.supplier_id }));

    const meterTypeOptions = [
        { label: "MPAN", value: 'MPAN' },
        { label: "SPID", value: 'SPID' },
        { label: "MPRN", value: 'MPRN' },
        { label: "CHP", value: 'CHP' },
        { label: 'SUB METER', value: 'SUB METER' }
    ];

    const meterStatusOptions = [
        { label: 'Active', value: 'active' },
        { label: 'Old', value: 'old' },
        { label: 'New', value: 'new' },
        // {label: 'Inactive', value: 'inactive'}
    ]

    const fetchProperty = async () => {
        try {
            const response = await getProperty(clientId!, propertyId!);
            setProperty(response)
            setMeters(response.meters);
            setClient(response.client);
        } catch (error: any) {
            toast.error(error?.message || "Failed to fetch Properties");
        }
    };

    const fetchUtilities = async () => {
        try {
            const response = await getUtilities();
            setUtilities(response)
        } catch (error: any) {
            toast.error(error?.message || "Failed to fetch Properties");
        }
    };

    const fetchUtility = async (utility_id: string) => {
        try {
            const data = await getUtility(utility_id);
            return data;
        } catch (error) {
            console.error("Error fetching utility suppliers:", error);
        }
    };

    const onSubmit: SubmitHandler<any> = async (data) => {
        try {
            const formData = new FormData();

            // 1. Extract image file from data
            let imageFile: File | null = null;
            if (data.image) {
                if (data.image instanceof File) {
                    imageFile = data.image;
                } else if (Array.isArray(data.image) && data.image.length > 0) {
                    imageFile = data.image[0];
                } else if (data.image.file instanceof File) {
                    imageFile = data.image.file;
                }
            }

            // 2. Remove image from data copy, then serialize rest to JSON
            const { image, ...meterDataWithoutImage } = data;
            Object.entries(meterDataWithoutImage).forEach(([key, value]) => {
                if (typeof value === 'string' || value instanceof Blob) {
                    formData.append(key, value);
                }
            });

            // 4. Append image file if exists
            if (imageFile) {
                formData.append('image', imageFile);
            }

            await addPropertyMeter(clientId, propertyId as string, formData);
            toast.success("Meter added successfully!");

            setLoading(false);

            // Optionally, reset form fields
            reset();
        } catch (error: any) {
            console.error("Error submitting meter:", error);
            toast.error(error.message || "Error submitting meter");
            setLoading(false);
        }
    };

    const meter_type = watch('meter_type');
    const edit_meter_type = editWatch('meter_type');

    return (
        <>
            <Breadcrumbs pageTitle='Property' />
            <Container className='default-dashboard' fluid>
                {property && (
                    <Row className="mb-4">
                        <Col sm="12">
                            <div className="p-4 border border-primary rounded shadow-sm">
                                <Row className="gy-3">
                                    <Col lg="4" md="6">
                                        <div>
                                            <small className="text-muted text-uppercase fw-semibold">Company Name</small>
                                            <div className="text-primary fw-bold" style={{ wordBreak: 'break-word' }}>{client?.name}</div>
                                        </div>
                                    </Col>
                                    <Col lg="4" md="6">
                                        <div>
                                            <small className="text-muted text-uppercase fw-semibold">Property</small>
                                            <div className="text-primary fw-bold" style={{ wordBreak: 'break-word' }}>{property?.name}</div>
                                        </div>
                                    </Col>
                                    <Col lg="4" md="6">
                                        <div>
                                            <small className="text-muted text-uppercase fw-semibold">No. of Meters</small>
                                            <div className="text-primary fw-bold">{meters?.length}</div>
                                        </div>
                                    </Col>
                                    <Col lg="8" md="12">
                                        <div>
                                            <small className="text-muted text-uppercase fw-semibold">Address</small>
                                            <div className="text-primary fw-bold" style={{ wordBreak: 'break-word' }}>{client?.address}</div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                )}

                <Row>
                    <Col sm="12" className="d-flex justify-content-end">
                        <Btn color='primary' className="mb-3" onClick={toggleMeterModal}>Add Meter</Btn>
                    </Col>

                    <Table title='Meter' tableColumns={tableColumns} data={meters} />
                </Row>
                <Modal modalClassName="modal-bookmark" isOpen={meterModalOpen} toggle={toggleMeterModal} size='lg'>
                    <ModalHeader toggle={toggleMeterModal}>{'Add New Meter'}</ModalHeader>
                    <ModalBody>
                        <Form className="theme-form mt-4 text-start" onSubmit={handleSubmit(onSubmit)}>
                            <Row style={{ marginTop: '5px' }}>
                                <Col sm={4}>
                                    <FormGroup>
                                        <Col><Label for="meter_name">Meter Name</Label><span className="text-danger">*</span></Col>
                                        <Controller
                                            name="meter_name"
                                            control={control}
                                            render={({ field }) => (
                                                <Input
                                                    id="meter_name"
                                                    type="text"
                                                    placeholder="Enter Meter Name"
                                                    {...field}
                                                />
                                            )}
                                        />
                                        {errors.meter_name && <p className="text-danger">{errors.meter_name.message}</p>}
                                    </FormGroup>
                                </Col>

                                <Col sm={4}>
                                    <FormGroup>
                                        <Controller
                                            name="meter_type"
                                            control={control}
                                            render={({ field }) => (
                                                <SelectDropdown
                                                    title="Meter Type"
                                                    options={meterTypeOptions}
                                                    value={field.value}
                                                    onOptionSelected={(val) => field.onChange(val)}
                                                />
                                            )}
                                        />
                                        {errors.meter_type && <p className="text-danger">{errors.meter_type.message}</p>}
                                    </FormGroup>
                                </Col>

                                <Col sm={4}>
                                    <FormGroup>
                                        <Col><Label for="meter_no_1">Meter Number</Label><span className="text-danger">*</span></Col>
                                        <Controller
                                            name="meter_no_1"
                                            control={control}
                                            render={({ field }) => (
                                                <Input
                                                    id="meter_no_1"
                                                    type="text"
                                                    placeholder="Enter Meter Number"
                                                    {...field}
                                                />
                                            )}
                                        />
                                        {errors.meter_no_1 && <p className="text-danger">{errors.meter_no_1.message}</p>}

                                        {meter_type === 'MPAN' &&
                                            <>
                                                <Controller
                                                    name="meter_no_2"
                                                    control={control}
                                                    render={({ field }) => (
                                                        <Input
                                                            id="meter_no_2"
                                                            type="text"
                                                            placeholder="Enter Meter Number 2"
                                                            {...field}
                                                        />
                                                    )}
                                                />
                                                {errors.meter_no_2 && <p className="text-danger">{errors.meter_no_2.message}</p>}
                                            </>
                                        }
                                    </FormGroup>
                                </Col>

                                <Col sm={4}>
                                    <FormGroup>
                                        <Col><Label for="site_id">Site ID</Label></Col>
                                        <Controller
                                            name="site_id"
                                            control={control}
                                            render={({ field }) => (
                                                <Input
                                                    id="site_id"
                                                    type="text"
                                                    placeholder="Enter Site ID"
                                                    {...field}
                                                />
                                            )}
                                        />
                                        {errors.site_id && <p className="text-danger">{errors.site_id.message}</p>}
                                    </FormGroup>
                                </Col>

                                <Col sm={4}>
                                    <FormGroup>
                                        <Controller
                                            name="utility_id"
                                            control={control}
                                            render={({ field }) => (
                                                <SelectDropdown
                                                    title="Utility"
                                                    options={utilityOptions}
                                                    value={field.value}
                                                    onOptionSelected={(val) => field.onChange(val)}
                                                />
                                            )}
                                        />
                                        {errors.utility_id && <p className="text-danger">{errors.utility_id.message}</p>}
                                    </FormGroup>
                                </Col>

                                <Col sm={4}>
                                    <FormGroup>
                                        <Controller
                                            name="supplier_id"
                                            control={control}
                                            render={({ field }) => (
                                                <SelectDropdown
                                                    title="Supplier"
                                                    options={supplierOptions}
                                                    value={field.value}
                                                    onOptionSelected={(val) => field.onChange(val)}
                                                />
                                            )}
                                        />
                                        {errors.supplier_id && <p className="text-danger">{errors.supplier_id.message}</p>}
                                    </FormGroup>
                                </Col>

                                <Col sm={4}>
                                    <FormGroup>
                                        <Col><Label for="location">Location</Label></Col>
                                        <Controller
                                            name="location"
                                            control={control}
                                            render={({ field }) => (
                                                <Input
                                                    id="location"
                                                    type="text"
                                                    placeholder="Enter Meter location"
                                                    {...field}
                                                />
                                            )}
                                        />
                                        {errors.location && <p className="text-danger">{errors.location.message}</p>}
                                    </FormGroup>
                                </Col>

                                <Col sm={4}>
                                    <Col><Label for="date_installed">Date Installed</Label></Col>
                                    <FormGroup>
                                        <Controller
                                            name="date_installed"
                                            control={control}
                                            render={({ field }) => (
                                                <Input
                                                    type="date"
                                                    placeholder='Select the date installed'
                                                    {...field}
                                                />
                                            )}
                                        />
                                        {errors.date_installed && <p className="text-danger">{errors.date_installed.message}</p>}
                                    </FormGroup>
                                </Col>

                                <Col sm={4}>
                                    <Col><Label for="contract_end_date">Contract End Date</Label></Col>
                                    <FormGroup>
                                        <Controller
                                            name="contract_end_date"
                                            control={control}
                                            render={({ field }) => (
                                                <Input
                                                    type="date"
                                                    placeholder='Select Contract End Date'
                                                    {...field}
                                                />
                                            )}
                                        />
                                        {errors.contract_end_date && <p className="text-danger">{errors.contract_end_date.message}</p>}
                                    </FormGroup>
                                </Col>

                                <Col sm={4}>
                                    <Col><Label for="data_collector">Data Collector</Label></Col>
                                    <FormGroup>
                                        <Controller
                                            name="data_collector"
                                            control={control}
                                            render={({ field }) => (
                                                <Input
                                                    id="data_collector"
                                                    type="text"
                                                    placeholder="Enter Data Collector"
                                                    {...field}
                                                />
                                            )}
                                        />
                                        {errors.data_collector && <p className="text-danger">{errors.data_collector.message}</p>}
                                    </FormGroup>
                                </Col>

                                <Col sm={4}>
                                    <Col><Label for="meter_operator">Meter Operator</Label></Col>
                                    <FormGroup>
                                        <Controller
                                            name="meter_operator"
                                            control={control}
                                            render={({ field }) => (
                                                <Input
                                                    id="meter_operator"
                                                    type="text"
                                                    placeholder="Enter Meter Operator"
                                                    {...field}
                                                />
                                            )}
                                        />
                                        {errors.meter_operator && <p className="text-danger">{errors.meter_operator.message}</p>}
                                    </FormGroup>
                                </Col>

                                <Col sm={4}>
                                    <FormGroup>
                                        <Controller
                                            name="status"
                                            control={control}
                                            render={({ field }) => (
                                                <SelectDropdown
                                                    title="Status"
                                                    options={meterStatusOptions}
                                                    value={field.value}
                                                    onOptionSelected={(val) => field.onChange(val)}
                                                />
                                            )}
                                        />
                                        {errors.status && <p className="text-danger">{errors.status.message}</p>}
                                    </FormGroup>
                                </Col>
                            </Row>

                            <div className="form-actions mt-3 text-end">
                                <button type="reset" className="btn btn-secondary mx-2" onClick={() => reset()}>Reset</button>
                                <button type="submit" className="btn btn-primary mx-2">Submit</button>
                            </div>
                        </Form>
                    </ModalBody>
                </Modal>

                <Modal modalClassName="modal-bookmark" isOpen={editModalOpen} toggle={toggleEditModal} size="lg">
                    <ModalHeader toggle={toggleEditModal}>{'Update Meter'}</ModalHeader>
                    <ModalBody>
                        <Form onSubmit={editHandleSubmit(handleEditMeter)}>
                            <Row style={{ marginTop: '5px' }}>
                                <Col sm={4}>
                                    <FormGroup>
                                        <Col><Label for="meter_name">Meter Name</Label><span className="text-danger">*</span></Col>
                                        <Controller
                                            name="meter_name"
                                            control={editControl}
                                            render={({ field }) => (
                                                <Input
                                                    id="meter_name"
                                                    type="text"
                                                    placeholder="Enter Meter Name"
                                                    {...field}
                                                />
                                            )}
                                        />
                                        {editErrors.meter_name && <p className="text-danger">{editErrors.meter_name.message}</p>}
                                    </FormGroup>
                                </Col>

                                <Col sm={4}>
                                    <FormGroup>
                                        <Controller
                                            name="meter_type"
                                            control={editControl}
                                            render={({ field }) => (
                                                <SelectDropdown
                                                    title="Meter Type"
                                                    options={meterTypeOptions}
                                                    value={field.value}
                                                    onOptionSelected={(val) => field.onChange(val)}
                                                />
                                            )}
                                        />
                                        {editErrors.meter_type && <p className="text-danger">{editErrors.meter_type.message}</p>}
                                    </FormGroup>
                                </Col>

                                <Col sm={4}>
                                    <FormGroup>
                                        <Col><Label for="meter_no_1">Meter Number</Label><span className="text-danger">*</span></Col>
                                        <Controller
                                            name="meter_no_1"
                                            control={editControl}
                                            render={({ field }) => (
                                                <Input
                                                    id="meter_no_1"
                                                    type="text"
                                                    placeholder="Enter Meter Number"
                                                    {...field}
                                                />
                                            )}
                                        />
                                        {editErrors.meter_no_1 && <p className="text-danger">{editErrors.meter_no_1.message}</p>}

                                        {edit_meter_type === 'MPAN' &&
                                            <>
                                                <Controller
                                                    name="meter_no_2"
                                                    control={editControl}
                                                    render={({ field }) => (
                                                        <Input
                                                            id="meter_no_2"
                                                            type="text"
                                                            placeholder="Enter Meter Number 2"
                                                            {...field}
                                                        />
                                                    )}
                                                />
                                                {editErrors.meter_no_2 && <p className="text-danger">{editErrors.meter_no_2.message}</p>}
                                            </>
                                        }
                                    </FormGroup>
                                </Col>

                                <Col sm={4}>
                                    <FormGroup>
                                        <Col><Label for="site_id">Site ID</Label></Col>
                                        <Controller
                                            name="site_id"
                                            control={editControl}
                                            render={({ field }) => (
                                                <Input
                                                    id="site_id"
                                                    type="text"
                                                    placeholder="Enter Site ID"
                                                    {...field}
                                                />
                                            )}
                                        />
                                        {editErrors.site_id && <p className="text-danger">{editErrors.site_id.message}</p>}
                                    </FormGroup>
                                </Col>

                                <Col sm={4}>
                                    <FormGroup>
                                        <Controller
                                            name="utility_id"
                                            control={editControl}
                                            render={({ field }) => (
                                                <SelectDropdown
                                                    title="Utility"
                                                    options={utilityOptions}
                                                    value={field.value}
                                                    onOptionSelected={(val) => field.onChange(val)}
                                                />
                                            )}
                                        />
                                        {editErrors.utility_id && <p className="text-danger">{editErrors.utility_id.message}</p>}
                                    </FormGroup>
                                </Col>

                                <Col sm={4}>
                                    <FormGroup>
                                        <Controller
                                            name="supplier_id"
                                            control={editControl}
                                            render={({ field }) => (
                                                <SelectDropdown
                                                    title="Supplier"
                                                    options={supplierOptions}
                                                    value={field.value}
                                                    onOptionSelected={(val) => field.onChange(val)}
                                                />
                                            )}
                                        />
                                        {editErrors.supplier_id && <p className="text-danger">{editErrors.supplier_id.message}</p>}
                                    </FormGroup>
                                </Col>

                                <Col sm={4}>
                                    <FormGroup>
                                        <Col><Label for="location">Location</Label></Col>
                                        <Controller
                                            name="location"
                                            control={editControl}
                                            render={({ field }) => (
                                                <Input
                                                    id="location"
                                                    type="text"
                                                    placeholder="Enter Meter location"
                                                    {...field}
                                                />
                                            )}
                                        />
                                        {editErrors.location && <p className="text-danger">{editErrors.location.message}</p>}
                                    </FormGroup>
                                </Col>

                                <Col sm={4}>
                                    <Col><Label for="date_installed">Date Installed</Label></Col>
                                    <FormGroup>
                                        <Controller
                                            name="date_installed"
                                            control={editControl}
                                            render={({ field }) => (
                                                <Input
                                                    type="date"
                                                    placeholder='Select the date installed'
                                                    {...field}
                                                />
                                            )}
                                        />
                                        {editErrors.date_installed && <p className="text-danger">{editErrors.date_installed.message}</p>}
                                    </FormGroup>
                                </Col>

                                <Col sm={4}>
                                    <Col><Label for="contract_end_date">Contract End Date</Label></Col>
                                    <FormGroup>
                                        <Controller
                                            name="contract_end_date"
                                            control={editControl}
                                            render={({ field }) => (
                                                <Input
                                                    type="date"
                                                    placeholder='Select Contract End Date'
                                                    {...field}
                                                />
                                            )}
                                        />
                                        {editErrors.contract_end_date && <p className="text-danger">{editErrors.contract_end_date.message}</p>}
                                    </FormGroup>
                                </Col>

                                <Col sm={4}>
                                    <Col><Label for="data_collector">Data Collector</Label></Col>
                                    <FormGroup>
                                        <Controller
                                            name="data_collector"
                                            control={editControl}
                                            render={({ field }) => (
                                                <Input
                                                    id="data_collector"
                                                    type="text"
                                                    placeholder="Enter Data Collector"
                                                    {...field}
                                                />
                                            )}
                                        />
                                        {editErrors.data_collector && <p className="text-danger">{editErrors.data_collector.message}</p>}
                                    </FormGroup>
                                </Col>

                                <Col sm={4}>
                                    <Col><Label for="meter_operator">Meter Operator</Label></Col>
                                    <FormGroup>
                                        <Controller
                                            name="meter_operator"
                                            control={editControl}
                                            render={({ field }) => (
                                                <Input
                                                    id="meter_operator"
                                                    type="text"
                                                    placeholder="Enter Meter Operator"
                                                    {...field}
                                                />
                                            )}
                                        />
                                        {editErrors.meter_operator && <p className="text-danger">{editErrors.meter_operator.message}</p>}
                                    </FormGroup>
                                </Col>

                                <Col sm={4}>
                                    <FormGroup>
                                        <Controller
                                            name="status"
                                            control={editControl}
                                            render={({ field }) => (
                                                <SelectDropdown
                                                    title="Status"
                                                    options={meterStatusOptions}
                                                    value={field.value}
                                                    onOptionSelected={(val) => field.onChange(val)}
                                                />
                                            )}
                                        />
                                        {editErrors.status && <p className="text-danger">{editErrors.status.message}</p>}
                                    </FormGroup>
                                </Col>
                            </Row>
                            <div className="form-actions mt-3 text-end">
                                <button type="reset" className="btn btn-secondary mx-2" onClick={() => { editReset(); toggleEditModal(); }}>Cancel</button>
                                <button type="submit" className="btn btn-primary mx-2" disabled={loading}>Update</button>
                            </div>
                        </Form>
                    </ModalBody>
                </Modal>
            </Container>
        </>
    );
}